var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Cascader',{attrs:{"data":_vm.data,"change-on-select":"","render-format":_vm.format,"load-data":_vm.loadData,"placeholder":_vm.$t('RegionSelection')},on:{"on-change":_vm.getCity},model:{value:(_vm.areaList),callback:function ($$v) {_vm.areaList=$$v},expression:"areaList"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f465b36","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/city/city.vue
// module id = null
// module chunks = 